import React from 'react';
import styles from './social-icons.module.css';

import TwitterIcon from '../../icons/Twitter';
import LinkedInIcon from '../../icons/LinkedIn';

const SocialIcons = () => (
    <ul className={styles.socialIcons}>
        <li><a href='https://www.linkedin.com/company/artiseq/'><LinkedInIcon /></a></li>
        <li><a href='https://twitter.com/artiseq'><TwitterIcon /></a></li>
    </ul>
);

export default SocialIcons;



// WEBPACK FOOTER //
// ./src/components/SocialIcons/index.js